import produce from 'immer'

import { IUser } from 'src/interfaces/user'

import {
  IRemoveProfileAction,
  ISetSelectedProfileAction,
  IUpdateSelectedProfileAction,
  IUserMeRequestErrorAction,
  IUserMeRequestSuccessAction,
  USER_ME_REQUEST_ERROR,
  USER_ME_REQUEST_SUCCESS,
  USER_REMOVE_PROFILE,
  USER_SET_SELECTED_PROFILE,
  USER_UPDATE_SELECTED_PROFILE
} from 'src/actions/user/user'
import { ANONYMOUS_PROFILE_ID, ANONYMOUS_USER_TYPE } from 'src/constants/user'

export const INITIAL_STATE: IUser = {
  confirmedAt: null,
  verifiedAt: null,
  hasToken: false,
  identities: [],
  loggedIn: false,
  loginRequestPending: false,
  remainingPhoneVerificationAttempts: 0,
  unconfirmedEmail: undefined,
  unverifiedPhone: undefined,
  profiles: {
    [ANONYMOUS_PROFILE_ID]: {
      isMessengerEnabled: true,
      type: ANONYMOUS_USER_TYPE
    }
  },
  receiveNewsletter: undefined,
  selectedProfileId: ANONYMOUS_PROFILE_ID
}

type Actions =
  | ISetSelectedProfileAction
  | IUpdateSelectedProfileAction
  | IUserMeRequestErrorAction
  | IUserMeRequestSuccessAction
  | IRemoveProfileAction;

const userReducer = (state = INITIAL_STATE, action: Actions): IUser =>
  produce(state, (draft) => {
    switch (action.type) {
      case USER_ME_REQUEST_SUCCESS:
        return {
          ...state,
          loginRequestPending: false,
          ...action.payload
        }

      case USER_ME_REQUEST_ERROR:
        draft.hasToken = false
        draft.loginRequestPending = false
        draft.loggedIn = false
        break

      case USER_UPDATE_SELECTED_PROFILE:
        draft.profiles[state.selectedProfileId] = {
          ...draft.profiles[state.selectedProfileId],
          ...action.payload
        }
        break
      case USER_REMOVE_PROFILE:
        delete draft.profiles[action.payload]
        break

      case USER_SET_SELECTED_PROFILE:
        draft.selectedProfileId = action.payload
        break
    }
  })

export default userReducer
